<template>
  <div class="ml-2">
    <div class="h-50px d-flex align-center mr-5">
      <v-select
        v-model="selects.grupos.value"
        :items="selects.grupos.items"
        label="Grupos de compras"
        item-text="descricao"
        item-value="id"
        height="10"
        outlined
        clearable
        dense
        hide-details
      />

      <v-switch
        v-model="checkbox_grupo_fornecedor"
        dense
        class="ml-3"
        hide-details
      >
        <template #label>
          <span class="pl-2 text-no-wrap">Grupos de análise</span>
        </template>
      </v-switch>

      <v-autocomplete
        v-if="checkbox_grupo_fornecedor"
        v-model="selects.grupos_fornecedores.value"
        :items="selects.grupos_fornecedores.items"
        label="Grupo Fornecedores"
        item-value="id"
        item-text="nome"
        height="10"
        clearable
        outlined
        dense
        class="ml-3"
        hide-details
      />

      <v-autocomplete
        v-else
        v-model="selects.fornecedores.value"
        :items="selects.fornecedores.items"
        label="Fornecedores"
        item-value="idfornecedor"
        item-text="razao_social"
        height="10"
        clearable
        outlined
        dense
        class="ml-3"
        hide-details
      />

      <v-autocomplete
        v-model="selects.compradores.value"
        :items="selects.compradores.items"
        label="Compradores"
        item-value="idcomprador"
        item-text="nome_comprador"
        height="10"
        clearable
        outlined
        dense
        class="ml-3"
        hide-details
      />

      <v-text-field
        v-model="dataInicial"
        label="Data inicial"
        type="date"
        outlined
        dense
        class="ml-3"
        hide-details
      />

      <v-text-field
        v-model="dataFinal"
        label="Data final"
        type="date"
        outlined
        dense
        class="ml-3"
        hide-details
        :error="erroPeriodoFinal === true"
      />

      <v-btn class="ml-3" @click="exportarPedidos()">
        <v-icon left>$Excel</v-icon>
        exportar
      </v-btn>

      <v-btn
        color="primary"
        class="ml-3" dark
        @click="getPedidos()"
      >
        <v-icon left>mdi-magnify</v-icon>
        Buscar
      </v-btn>
    </div>

    <v-divider class="mr-2"/>

    <sys-data-table
      v-model="pedidos_selecionados_para_deletar"
      :headers="HEADERS_COMPUTED"
      :items="LISTA_PEDIDOS"
      :height="alturaDaJanela - 272"
      :item-height="45"
      :search="pesquisa"
      show-select
      item-key="idpedido"
      class="text-gray-1100"
    >
      <template #top>
        <div class="d-flex align-center w-full pt-10px pb-1 pr-2">
          <v-icon class="mr-1" :size="20">mdi-format-list-bulleted</v-icon>
          <span class="font-weight-medium font-17">Lista de pedidos</span>

          <v-btn
            v-show="pedidos_selecionados_para_deletar.length > 0"
            color="red"
            dark
            small
            class="ml-2"
            @click="deleteItem(pedidos_selecionados_para_deletar)"
          >
            <v-icon class="mr-1" size="20">mdi-delete</v-icon>
            remover
            <span class="qtde-top-button-small">{{ pedidos_selecionados_para_deletar.length }}</span>
          </v-btn>

          <v-spacer/>

          <div class="w-250 mr-3 my-n1">
            <SysAutocomplete
              v-model="selects.id_erp.value"
              :items_props="selects.id_erp.items"
              :dense_props="true"
              label_props="ID ERP"
              :qtde-visivel-selecionados="1"
            />
          </div>

          <div class="w-250 mr-3 my-n1">
            <v-select
              v-model="selects.status.value"
              :items="selects.status.items"
              label="Status"
              item-text="descricao"
              item-value="id"
              outlined
              clearable
              dense
              hide-details
            />
          </div>

          <div class="w-450">
            <v-text-field
              v-model="pesquisa"
              append-icon="mdi-magnify"
              label="Pesquisar"
              dense
              hide-details
              clearable
              v-lazy-input:debounce="500"
            />
          </div>
        </div>
      </template>

      <template #item.status="{item}">
        <span v-if="item.status === 'AB'">Aberto</span>
        <span v-else-if="item.status === 'CL'">Cancelado</span>
        <span v-else-if="item.status === 'CT'">Cotação</span>
        <span v-else-if="item.status === 'FN'">Finalizado</span>
      </template>

      <template #item.observacao="{value}">
        <div v-text="value || '-'" class="w-max-100 text-truncate text-center" :title="value" />
      </template>

      <template #item.pedido_cli="{item}">
        <div class="d-flex align-center">
          <span v-if="item.pedido_cli === 'NAO_PROCESSADO_NO_WINTHOR'" class="mr-n2">Aguardando</span>
          <span v-else class="mr-n2">{{ String(item.pedido_cli) === '0' ? '-' : item.pedido_cli }}</span>

          <ResultadoExportacaoComSucessoCissPoderIntegrimDialog
            v-if="integracao_exportacao_cisspoder_integrim && String(item.pedido_cli) !== '0'"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoGemcoDialog
            v-if="integracao_exportacao_gemco && String(item.pedido_cli) !== '0'"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoCitelDialog
            v-if="integracao_exportacao_citel && String(item.pedido_cli) !== '0'"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoConsincoDialog
            v-if="compras_exportacao_api_consinco && String(item.pedido_cli) !== '0'"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoNativaWinthorDialog
            v-if="compras_exportacao_nativa_winthor && String(item.pedido_cli) !== '0'"
            :idpedido_systock="Number(item.idpedido)"
          />
        </div>
      </template>

      <template #item.total_itens="{item}">
        {{ Helpers.formatarValor(item.total_itens) }}
      </template>

      <template #item.nome_comprador="{value}">
        <div v-text="value || '-'" class="w-max-200 text-truncate" :title="value"/>
      </template>

      <template #item.nome_fornecedor="{value}">
        <div v-text="value || '-'" class="w-max-200 text-truncate" :title="value"/>
      </template>

      <template #item.inicio_cotacao="{value}">
        <div v-text="value || '-'" class="text-center"/>
      </template>

      <template #item.data_final="{value}">
        <div v-text="value || '-'" class="text-center"/>
      </template>

      <template #item.data_previsao_entrega="{value}">
        <div v-text="value || '-'" class="text-center"/>
      </template>

      <template #item.valor_total="{value}">
        {{ Helpers.formatarValorMonetario(value) }}
      </template>

      <template #item.icon_acoes1="{item}">
        <v-btn icon v-if="item.status === 'CT'" @click="finalizarCotacaoPedido(item)">
          <v-icon title="Finalizar Cotação do Pedido" color="green">mdi-cart-arrow-right</v-icon>
        </v-btn>
      </template>

      <template #item.icon_acoes2="{item}">
        <v-btn icon v-if="item.status === 'CT'" @click="cancelarCotacao(item)">
          <v-icon title="Cancelar Cotação" color="red">mdi-file-cancel</v-icon>
        </v-btn>
      </template>

      <template #item.icon_acoes3="{item}">
        <v-btn icon v-if="item.status === 'FN'" @click="reabrirPedidoCompra(item)">
          <v-icon title="Reabrir Pedido de Compra">
            mdi-lock-open
          </v-icon>
        </v-btn>

        <v-btn icon v-else @click="abrirPedidoTelaCompras(item)">
          <v-icon title="Abrir na tela de compras">mdi-cart</v-icon>
        </v-btn>
      </template>

      <template #item.icon_acoes4="{item}">
        <v-btn
          v-if="item.produto_eh_combinacao"
          icon
          @click="dialog_relatorios = !dialog_relatorios;pedido_selecionado = item;"
        >
          <v-icon>mdi-file-document</v-icon>
        </v-btn>
      </template>

      <template #item.icon_acoes5="{item}">
        <v-btn icon @click="exibirItensPedido(item)">
          <v-icon title="Exibir Itens do Pedido">
            mdi-chart-line
          </v-icon>
        </v-btn>
      </template>

      <template #item.icon_acoes6="{item}">
        <v-btn icon @click="deleteItem([item])">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </sys-data-table>

    <SysDialogDelete
      :item="pedido_a_deletar"
      :url_delete="`/pedidos-compra/deletar-pedido`"
      @reset-item="pedido_a_deletar = []"
      @deleted="getPedidos(); pedido_a_deletar = []; pedidos_selecionados_para_deletar = [];"
    >
      Deseja realmente fazer a exclusão?
    </SysDialogDelete>

    <RelatoriosDeExportacao v-model="dialog_relatorios" :pedido="pedido_selecionado"/>
  </div>
</template>

<script>
import DrpAPI from "./../../api/drp";
import PedidoAPI from "./../../api/pedido";
import {required} from "vuelidate/lib/validators";
import CarrinhoAPI from "./../../api/carrinho";
import {mapGetters} from "vuex";
import RelatoriosDeExportacao from "./RelatoriosDeExportacao";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import $axios from "@/api/api";
import {logout} from "@/helpers";
import ResultadoExportacaoComSucessoCissPoderIntegrimDialog from '@/components/compra/carrinho/Exportacoes/ExportacaoCissPoderIntegrim/ResultadoExportacaoComSucessoDialog.vue';
import ResultadoExportacaoComSucessoGemcoDialog from '@/components/compra/carrinho/Exportacoes/ExportacaoGemco/ResultadoExportacaoComSucessoDialog.vue';
import ResultadoExportacaoComSucessoCitelDialog from '@/components/compra/carrinho/Exportacoes/ExportacaoGemco/ResultadoExportacaoComSucessoDialog.vue';
import ResultadoExportacaoComSucessoConsincoDialog from '@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosConsinco/PedidoCompra/ResultadoExportacaoComSucessoDialog.vue';
import ResultadoExportacaoComSucessoNativaWinthorDialog from '@/components/compra/carrinho/Exportacoes/NativaWinthor/ResultadoExportacaoComSucessoDialog.vue';
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import SysDialogDelete from "@/components/utils/SysDialogDelete.vue";
import SysAutocomplete from "../utils/crud/SysAutocomplete.vue";

export default {
  name: "Drp",
  mixins: [ResponsiveHeight],
  components: {
    RelatoriosDeExportacao,
    ResultadoExportacaoComSucessoCissPoderIntegrimDialog,
    ResultadoExportacaoComSucessoGemcoDialog,
    ResultadoExportacaoComSucessoCitelDialog,
    ResultadoExportacaoComSucessoConsincoDialog,
    ResultadoExportacaoComSucessoNativaWinthorDialog,
    SysDialogDelete,
    SysAutocomplete
  },
  data() {
    return {
      dataInicial: 0,
      dataFinal: 0,
      getItens: 0,
      selects: {
        grupos: {
          items: [],
          value: "",
        },
        fornecedores: {
          items: [],
          value: "",
        },
        compradores: {
          items: [],
          value: "",
        },
        fornecedor: {
          items: [],
          value: "",
        },
        grupos_fornecedores: {
          items: [],
          value: ""
        },
        id_erp: {
          items: [],
          value: [],
        },
        status: {
          items: [
            {id: 'AB', descricao: 'Aberto'},
            {id: 'CL', descricao: 'Cancelado'},
            {id: 'CT', descricao: 'Cotação'},
            {id: 'FN', descricao: 'Finalizado'},
          ],
          value: null,
        }
      },
      headers: [
        {text: "ID Systock", value: "idpedido", style: {width: '90px'}},
        {text: "ID ERP", value: "pedido_cli"},
        {text: "Grupo", value: "nome_grupo", style: {width: '90px'}},
        {text: "Comprador", value: "nome_comprador"},
        {text: "Segmento", value: "nome_segmento"},
        {text: "Fornecedor", value: "nome_fornecedor"},
        {text: "UF", value: "uf"},
        {text: "Data emissão", value: "data_emissao", style: {width: '90px'}},
        {text: "Início cotação", value: "inicio_cotacao", style: {width: '96px'}},
        {text: "Data finalização", value: "data_final", style: {width: '110px'}},
        {text: "Previsão recebimento", value: "data_previsao_entrega", style: {width: '140px'}},
        {text: "Status", value: "status"},
        {text: "Observação", value: "observacao"},
        {text: "Qtde. produtos", value: "total_itens"},
        {text: "Total", value: "valor_total"},
        {text: "", value: "icon_acoes1", sortable: false},
        {text: "", value: "icon_acoes2", sortable: false},
        {text: "", value: "icon_acoes3", sortable: false},
        {text: "", value: "icon_acoes4", sortable: false},
        {text: "", value: "icon_acoes5", sortable: false},
        {text: "", value: "icon_acoes6", sortable: false},
      ],
      existe_pedidos_exportados: false,
      listaPedidos: [],
      editedItem: {
        fornecedor: "",
        diasIntervalo: "",
        editedItem: "",
      },
      dialog_relatorios: false,
      pedido_selecionado: {},
      checkbox_grupo_fornecedor: false,
      pesquisa: '',
      integracao_exportacao_cisspoder_integrim: localStorage.integracao_exportacao_cisspoder_integrim === 'S',
      integracao_exportacao_gemco: localStorage.integracao_exportacao_gemco === 'S',
      integracao_exportacao_citel: localStorage.integracao_exportacao_citel === 'S',
      compras_exportacao_nativa_winthor: localStorage.compras_exportacao_nativa_winthor === 'S',
      compras_exportacao_api_consinco: localStorage.compras_exportacao_api_consinco === 'S',
      pedidos_selecionados_para_deletar: [],
      pedido_a_deletar: []
    };
  },
  validations: {
    editedItem: {
      fornecedor: {
        required,
      },
      diasIntervalo: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    erroPeriodoFinal() {
      return this.dataInicial > this.dataFinal &&
        this.dataFinal != 0 &&
        this.dataFinal != "";
    },
    HEADERS_COMPUTED() {
      if (this.existe_pedidos_exportados) {
        return this.headers;
      }
      return this.headers.filter(item => item.value !== 'pedido_cli');
    },
    FILTROS_STORE_TELA_COMPRAS_PRODUTOS_FILTROS: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getFiltros'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/setFiltros', valor);
      }
    },
    LISTA_PEDIDOS() {

      let lista = this.listaPedidos;

      if (this.selects.id_erp.value && this.selects.id_erp.value.length > 0) {
        lista = lista.filter(pedido => this.selects.id_erp.value.includes(pedido.pedido_cli));
      }

      if (this.selects.status.value === 'AB' || this.selects.status.value === 'CL' || this.selects.status.value === 'CT' || this.selects.status.value === 'FN') {
        return lista.filter(pedido => pedido.status === this.selects.status.value);
      }

      if (this.selects.status.value === '' || this.selects.status.value === null) {
        return lista;
      }
    }
  },
  created() {
    this.buscarGrupos();
    this.getGruposFornecedores();
    this.getFornecedores();

    if (this.$route.query.idusuario && this.$route.query.idpedido) {
      this.getCompradoresPedidos(Number(this.$route.query.idusuario));
      this.pesquisa = String(this.$route.query.idpedido);
    } else {
      this.getCompradoresPedidos(Number(localStorage.getItem("id")));
    }
  },

  watch: {
    checkbox_grupo_fornecedor() {
      this.selects.grupos_fornecedores.value = '';
      this.selects.fornecedores.value = '';
      this.getPedidos();
    }
  },

  methods: {
    deleteItem(item) {
      this.pedido_a_deletar = item;
    },
    finalizarCotacaoPedido(item) {
      if (confirm("Deseja realmente finalizar a cotação deste pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {pedido: item.idpedido};

        this.$store.dispatch(
          "loading/addRequisicao",
          CarrinhoAPI.finalizarPedido(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.getPedidos();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    cancelarCotacao(item) {
      if (confirm("Deseja realmente cancelar a cotação deste pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {idpedido: item.idpedido};

        this.$store.dispatch(
          "loading/addRequisicao",
          PedidoAPI.cancelarCotacao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.getPedidos();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    abrirPedidoTelaCompras(item) {
      localStorage.setItem("analiseGrupoFornecedores", this.checkbox_grupo_fornecedor ? 'S' : 'N');

      this.$store.dispatch("usuario/setGrupoCompras", item.grupo);
      this.$store.dispatch("usuario/setFilialCompras", (item.filial_compra > 0) ? item.filial_compra : '0');

      localStorage.config_multifilial_distribuir_por_filial = 'N';
      this.$store.dispatch('CompraDistribuidaPorFilial/set_distribuir_por_filial', false);

      const params_pedido = {
        id: item.idfornecedor,
        razao_social: item.nome_fornecedor,
      };

      if (String(item.idfornecedor) === String(info_pedido_geral.idfornecedor)) {
        this.FILTROS_STORE_TELA_COMPRAS_PRODUTOS_FILTROS = {
          ...this.FILTROS_STORE_TELA_COMPRAS_PRODUTOS_FILTROS,
          filiais: item.filial_compra > 0 ? [item.filial_compra] : [],
          secoes: item.idsecao > 0 ? [item.idsecao] : [],
          segmentos: item.iddepartamento > 0 ? [item.iddepartamento] : [],
          compra_produtos_combinados_ativa: false,
        };

        this.$router.push({name: 'CompraPorProdutosGerais'});
      } else if (String(item.idfornecedor) === String(info_pedido_geral.idfornecedor_produtos_combiados)) {
        this.FILTROS_STORE_TELA_COMPRAS_PRODUTOS_FILTROS = {
          ...this.FILTROS_STORE_TELA_COMPRAS_PRODUTOS_FILTROS,
          filiais: item.filial_compra > 0 ? [item.filial_compra] : [],
          compra_produtos_combinados_ativa: true,
        };

        this.$router.push({name: 'CompraPorProdutosGerais'});
      } else {
        this.Helpers.buscarCompraFornecedor(params_pedido, 1);
      }
    },
    reabrirPedidoCompra(item) {
      if (confirm("Deseja realmente reabrir este pedido?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          pedido: item.idpedido,
          idfornecedor: item.idfornecedor,
          grupo: item.grupo,
          filial: item.filial_compra,
        };

        this.$store.dispatch("usuario/setFilialCompras", item.filial_compra);

        this.$store.dispatch(
          "loading/addRequisicao",
          PedidoAPI.reabrirPedidoCompra(headers, params)
            .then((response) => {
              const {token, pedido} = response.data;
              localStorage.setItem("token", token);

              if (pedido[0].existe > 0) {
                alert("Para reabrir um pedido você deve fechar o atualmente aberto(" + pedido[0].idpedido + ").");
              } else {
                if ([info_pedido_geral.idfornecedor, info_pedido_geral.idfornecedor_produtos_combiados].includes(Number(item.idfornecedor))) {
                  const filtros = this.$store.getters['CompraProdutosGerais/getFiltros'];

                  if (item.iddepartamento > 0) {
                    filtros.segmentos = [item.iddepartamento];
                  }

                  if (item.idsecao > 0) {
                    filtros.secoes = [item.idsecao];
                  }

                  filtros.compra_produtos_combinados_ativa = Number(item.idfornecedor) === info_pedido_geral.idfornecedor_produtos_combiados;

                  this.$store.dispatch('CompraProdutosGerais/setFiltros', filtros);
                  this.$router.push({name: "CompraPorProdutosGerais"});
                } else {
                  this.abrirPedidoTelaCompras(item);
                }
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    buscarGrupos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getGruposDrp(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            const grupos = response.data.grupos;

            grupos.forEach((grupo) => {
              this.selects.grupos.items.push(grupo);
            });

            let objGrupo = {
              id: 0,
              descricao: "Todos",
            };
            this.selects.grupos.items.push(objGrupo);
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getCompradoresPedidos(idcomprador) {
      const headers = this.Helpers.iniciarRequisicao();

      this.selects.compradores.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getCompradoresPedidos(headers)
          .then((response) => {
            const {token, compradores} = response.data;
            localStorage.setItem("token", token);

            this.selects.compradores.items.push({
              idcomprador: 0,
              nome_comprador: "Todos",
            });

            compradores.forEach((comprador) => {
              comprador.nome_comprador = `${comprador.idcomprador} - ${comprador.nome_comprador}`;
              this.selects.compradores.items.push(comprador);
            });

            const comprador_tem_pedido = compradores.some(item => Number(item.idcomprador) === idcomprador);

            if (comprador_tem_pedido) {
              this.selects.compradores.value = idcomprador;
              this.getPedidos();
            } else {
              this.selects.compradores.value = 0;
            }
          })
          .catch(logout)
      );
    },
    getGruposFornecedores() {
      const headers = this.Helpers.iniciarRequisicao();

      this.selects.grupos_fornecedores.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getGruposFornecedores(headers)
          .then((response) => {
            const {token, grupos_fornecedores} = response.data;
            localStorage.setItem("token", token);

            const forn = grupos_fornecedores;

            this.selects.grupos_fornecedores.items.push({
              id: 0,
              nome: "Todos",
            });

            forn.forEach((fornecedor) => {
              fornecedor.nome = fornecedor.id + " - " + fornecedor.nome;
              this.selects.grupos_fornecedores.items.push(fornecedor);
            });
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getFornecedores() {
      const headers = this.Helpers.iniciarRequisicao();

      this.selects.fornecedores.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getFornecedores(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            const forn = response.data.fornecedores;

            this.selects.fornecedores.items.push({
              idfornecedor: 0,
              razao_social: "Todos",
            });

            forn.forEach((fornecedor) => {
              fornecedor.razao_social =
                fornecedor.idfornecedor + " - " + fornecedor.razao_social;

              this.selects.fornecedores.items.push(fornecedor);
            });
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getPedidos() {
      if (!this.erroPeriodoFinal) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.selects.grupos.value,
          grupos_fornecedores: this.selects.grupos_fornecedores.value,
          check: this.checkbox_grupo_fornecedor,
          fornecedor: this.selects.fornecedores.value,
          comprador: this.selects.compradores.value,
          periodoIni: this.dataInicial != 0 ? this.dataInicial : null,
          periodoFin: this.dataFinal != 0 ? this.dataFinal : null
        };

        this.listaPedidos = [];
        this.selects.id_erp.value = [];
        this.selects.status.value = null;

        this.$store.dispatch(
          "loading/addRequisicao",
          PedidoAPI.getPedidosCompra(headers, params)
            .then((response) => {
              const {token, pedidos_compras, existe_pedidos_exportados} = response.data;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.listaPedidos = pedidos_compras;
                this.existe_pedidos_exportados = existe_pedidos_exportados;
                this.populaSelectIdErp(pedidos_compras);
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        alert("O período Final deve ser igual ou posterior ao período Inicial.");
      }
    },
    populaSelectIdErp(pedidos) {
      this.selects.id_erp.items = [];

      pedidos.forEach((pedido) => {

        if (!pedido.pedido_cli || pedido.pedido_cli === '0') return;

        if (
          pedido.pedido_cli === 'NAO_PROCESSADO_NO_WINTHOR'
          && !this.selects.id_erp.items.some(item => item.id === pedido.pedido_cli)
        ) {
          this.selects.id_erp.items.unshift({
            id: pedido.pedido_cli,
            descricao: 'Aguardando',
          });
          return;
        }

        if (pedido.pedido_cli !== 'NAO_PROCESSADO_NO_WINTHOR') {
          this.selects.id_erp.items.push({
            id: pedido.pedido_cli,
            descricao: pedido.pedido_cli,
          });
        }

      });
    },
    exibirItensPedido(pedido) {
      this.$emit("update:pedido_selecionado", pedido);
      this.$emit("getItens", (this.getItens += 1));
    },
    exportarPedidos() {
      const url = 'relatorios/pedidos-compra'
        + `?grupo=${this.selects.grupos.value}`
        + `&grupos_fornecedores=${this.selects.grupos_fornecedores.value || ''}`
        + `&fornecedor=${this.selects.fornecedores.value || ''}`
        + `&comprador=${this.selects.compradores.value || ''}`
        + `&periodoIni=${this.dataInicial || ''}`
        + `&periodoFin=${this.dataFinal || ''}`
        + `&analise_grupo_fornecedores=${this.checkbox_grupo_fornecedor ? 'S' : 'N'}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
    }
  },
};
</script>

<style scoped>
</style>

